<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? $t("AddNew") + " " + $t("WalletTransactionType") : $t("Update") + " " + $t("WalletTransactionType") }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="p-6"><vs-input :label="$t('Code')" v-model="Code" class="mt-5 w-full" /></div>
    <div class="p-6"><vs-input :label="$t('NameAR')" v-model="NameAr" class="mt-5 w-full" /></div>
    <div class="p-6"><vs-input :label="$t('NameEN')" v-model="NameEn" class="mt-5 w-full" /></div>
    <div class="p-6"><vs-checkbox v-model="IsActive">{{ $t("IsActive") }}</vs-checkbox></div>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{ $t("Save") }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t("Cancel") }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  props: { isSidebarActive: { type: Boolean, required: true }, data: { type: Object, default: () => ({}) } },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) this.initValues();
      else {
        let { ID, Code, NameAr, NameEn, IsActive } = JSON.parse(JSON.stringify(this.data));
        this.ID = ID || 0; this.Code = Code || ""; this.NameAr = NameAr || ""; this.NameEn = NameEn || ""; this.IsActive = IsActive !== false;
      }
    }
  },
  data() { return { ID: 0, Code: "", NameAr: "", NameEn: "", IsActive: true }; },
  computed: {
    isSidebarActiveLocal: { get() { return this.isSidebarActive; }, set(val) { if (!val) this.$emit("closeSidebar"); } },
    isFormValid() { return this.NameAr && this.Code; }
  },
  methods: {
    initValues() { this.ID = 0; this.Code = ""; this.NameAr = ""; this.NameEn = ""; this.IsActive = true; },
    submitData() {
      const obj = { ID: this.ID, Code: this.Code, NameAr: this.NameAr, NameEn: this.NameEn, IsActive: this.IsActive };
      if (this.ID && this.ID > 0) {
        this.$store.dispatch("walletTransactionTypeList/updateItem", obj).then(() => {
          this.$store.dispatch("walletTransactionTypeList/fetchDataListItems"); this.initValues(); this.$emit("closeSidebar");
          this.$vs.notify({ time: 5000, color: "success", title: this.$t("Success"), text: this.$t("UpdatedSuccessfully") });
        }).catch((err) => {
          this.$vs.notify({ time: 4000, title: this.$t("Error"), text: err && err.response && err.response.data && err.response.data.Message ? err.response.data.Message : this.$t("Error"), iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
        });
      } else {
        delete obj.ID;
        this.$store.dispatch("walletTransactionTypeList/addItem", obj).then(() => {
          this.$store.dispatch("walletTransactionTypeList/fetchDataListItems"); this.initValues(); this.$emit("closeSidebar");
          this.$vs.notify({ time: 5000, color: "success", title: this.$t("Success"), text: this.$t("SavedSuccessfully") });
        }).catch((err) => {
          this.$vs.notify({ time: 4000, title: this.$t("Error"), text: err && err.response && err.response.data && err.response.data.Message ? err.response.data.Message : this.$t("Error"), iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
        });
      }
    }
  }
};
</script>
